import './airportField';
import { de, en, es, fr, it, sv } from './i18n';


export const i18n = {

  /**
   * German translation.
   * @type {Object}
   */
  de,

  /**
   * English translation.
   * @type {Object}
   */
  en,

  /**
   * Spanish translation.
   * @type {Object}
   */
  es,

  /**
   * French translation.
   * @type {Object}
   */
  fr,

  /**
   * Italian translation.
   * @type {Object}
   */
  it,

  /**
   * Swedish translation.
   * @type {Object}
   */
  sv

};

/**
 * Init airport fields.
 */
export default function initAirportFields() {

  /**
   * German translation.
   */
  if($('.airport-field-de').length > 0) {
    $('.airport-field-de').each(function() {
      const $field = $(this);
      if(!$field.hasClass('hasAirportSuggestions')) {
        $('.airport-field-de').airportField({ i18n: de });
      }
    });
  }

  /**
   * English airportFields.
   */
  if($('.airport-field-en').length > 0) {
    $('.airport-field-en').each(function() {
      const $field = $(this);
      if(!$field.hasClass('hasAirportSuggestions')) {
        $('.airport-field-en').airportField({ i18n: en });
      }
    });
  }

  /**
   * Spanish airportFields.
   */
  if($('.airport-field-es').length > 0) {
    $('.airport-field-es').each(function() {
      const $field = $(this);
      if(!$field.hasClass('hasAirportSuggestions')) {
        $('.airport-field-es').airportField({ i18n: es });
      }
    });
  }

  /**
   * French airportFields.
   */
  if($('.airport-field-fr').length > 0) {
    $('.airport-field-fr').each(function() {
      var $field = $(this);
      if(!$field.hasClass('hasAirportSuggestions')) {
        $('.airport-field-fr').airportField({ i18n: fr });
      }
    });
  }

  /**
   * Italian airportFields.
   */
  if($('.airport-field-it').length > 0) {
    $('.airport-field-it').each(function() {
      const $field = $(this);
      if(!$field.hasClass('hasAirportSuggestions')) {
        $('.airport-field-it').airportField({ i18n: it });
      }
    });
  }

  /**
   * Swedish airportFields.
   */
  if($('.airport-field-sv').length > 0) {
    $('.airport-field-sv').each(function() {
      const $field = $(this);
      if(!$field.hasClass('hasAirportSuggestions')) {
        $('.airport-field-sv').airportField({ i18n: sv });
      }
    });
  }

}
